import { BaseLayoutFactory } from '../../../../components/base-layout-factory';
import { AmendmentDetailProvider } from './context/amendment-detail-context';
import { AmendmentDetailComponent } from './amendment-detail-component';

export function AmendmentDetailFactory() {
    return (
        <BaseLayoutFactory>
            <AmendmentDetailProvider>
                <AmendmentDetailComponent />
            </AmendmentDetailProvider>
        </BaseLayoutFactory>
    );
}
